var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('v-uni-view',{staticClass:"header_c"},[_c('v-uni-view',{staticClass:"category"},[_c('v-uni-view',{staticClass:"logo",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.handleToHome()
}}}),_c('v-uni-view',{staticClass:"editor"}),_c('v-uni-view',{staticClass:"tab"},_vm._l((_vm.tabList),function(item,index){return _c('v-uni-view',{key:index,staticClass:"item",class:_vm.tabIndex === index ? 'active' : '',on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.handleTab(item,index)
}}},[_vm._v(_vm._s(item))])}),1)],1),_c('v-uni-view',{staticClass:"header_r"},[_c('v-uni-view',{staticClass:"item"},[_c('v-uni-view',{staticClass:"bg_login"}),_c('v-uni-view',{staticClass:"desc"},[_c('v-uni-view',{staticClass:"login",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.handleLogin()
}}},[_vm._v(_vm._s(_vm.isToken ? _vm.phone : '登录/注册'))]),(_vm.isToken ? true : false)?_c('v-uni-view',{staticClass:"loginOut",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.handleLoginOut()
}}},[_vm._v("【退出】")]):_vm._e()],1)],1),_c('v-uni-view',{staticClass:"item",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.handleCart()
}}},[_c('v-uni-view',{staticClass:"bg_cart"}),_c('v-uni-view',{staticClass:"desc"},[_vm._v("购物车")])],1),_c('v-uni-view',{staticClass:"item",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.handleService()
}}},[_c('v-uni-view',{staticClass:"bg_consult"}),_c('v-uni-view',{staticClass:"desc"},[_vm._v("我要咨询")])],1)],1)],1)],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }